import type { FiscalYearResponse } from "@/types/draftCalendar";
import type { UserResponse } from "@/types/settings";

export const navItems = [
  { label: "Mable", href: "/home" },
  { label: "Dashboard", href: "/dashboard", permission: ["CanViewDashboard", "CanViewGRCDashboard"] },
  { label: "GRC", href: "/grcdashboard", permission: "CanViewGRCReport" },
  { label: "Draft Calendar", href: "/draftcalendar", permission: "CanViewDraftCalender" },
  { label: "Settings", href: "/settings", permission: "CanViewSettings" },
  { label: "Message Log", href: "/message-monitor", permission: "CanViewMessageLog" }
] as const;

function normalize(value: string | null | undefined) {
  return value?.replace(/\s+/g, "").toLowerCase() ?? "";
}

export function isApproverRole(user: UserResponse | undefined) {
  const roleCode = user?.roles?.roleCode ?? user?.roleCode;
  return roleCode === "business_approver" || roleCode === "business_reviewer";
}

export function getActiveFiscalYear(fiscalYears: FiscalYearResponse[]) {
  return fiscalYears.find((fy) => normalize(fy.submissionStatus) !== "closed") ?? fiscalYears[0];
}

export function isCalendarSubmitted(fiscalYears: FiscalYearResponse[]) {
  return normalize(getActiveFiscalYear(fiscalYears)?.submissionStatus) === "submitted";
}

export function shouldSkipDashboardForUser(user: UserResponse | undefined, fiscalYears: FiscalYearResponse[], isLoadingFiscalYears: boolean) {
  if (!isApproverRole(user)) return false;
  const perms = user?.permissions ?? [];
  if (perms.includes("CanViewDashboard") || perms.includes("CanViewGRCDashboard")) return false;
  return !isLoadingFiscalYears && !isCalendarSubmitted(fiscalYears);
}

export function getAllowedNavItems(user: UserResponse | undefined, shouldSkipDashboard: boolean) {
  const userPermissions = user?.permissions ?? [];

 return navItems.filter((item) => {
    if (shouldSkipDashboard && item.href === "/dashboard") return false;
    if (!("permission" in item)) return true;
    const perms = item.permission;
    if (typeof perms === "string") return userPermissions.includes(perms);
    return perms.some((p) => userPermissions.includes(p));
  });
}